module.exports = __webpack_public_path__ + "static/media/sign-out.9c2f5ae5.svg";